// @flow

import Resource from 'speed-js-core/src/api/Resource';

export default class BillingPolicyResource extends Resource {
    basePath: string = 'billing/billing-policy/';

    objectPath: string = 'billing/billing-policy/{ident}/';
}
